import { MapPin, Phone, Mail } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_rugged-convertion/artifacts/7zmfhnu6_ALEGER%20Logo%20Transparent.png";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#0B1121] text-slate-300 border-t border-blue-600/40" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img
            src={LOGO_URL}
            alt="ALEGER GLOBAL"
            className="h-10 w-auto mb-5"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <p className="text-sm text-slate-400 leading-relaxed">{t.footer.about}</p>
        </div>

        {t.footer.cols.map((col) => (
          <div key={col.title}>
            <h4 className="font-display font-bold text-white text-xs uppercase tracking-widest mb-4">{col.title}</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              {col.items.map((item, idx) => {
                if (col.title === "KONTAKT" || col.title === "CONTACT") {
                  const Icon = idx === 0 ? MapPin : idx === 1 ? Phone : Mail;
                  return (
                    <li key={item} className="flex items-start gap-2">
                      <Icon size={14} className="mt-0.5 text-blue-500 shrink-0" />
                      <span>{item}</span>
                    </li>
                  );
                }
                return <li key={item} className="hover:text-blue-500 cursor-default">{item}</li>;
              })}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} ALEGER GLOBAL GmbH. {t.footer.rights}</div>
          <div className="flex gap-4">
            <a href="https://alegerglobal.com/impressum/" className="hover:text-blue-500">{t.footer.legal.imprint}</a>
            <a href="https://alegerglobal.com/data-security/" className="hover:text-blue-500">{t.footer.legal.privacy}</a>
            <a href="https://alegerglobal.com/agbs/" className="hover:text-blue-500">{t.footer.legal.terms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
